/**
 * @generated SignedSource<<6e11395bc5848b01775d49d0353916bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveCob_charge$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkActiveRoot_charge">;
  readonly " $fragmentType": "PaymentActiveCob_charge";
};
export type PaymentActiveCob_charge$key = {
  readonly " $data"?: PaymentActiveCob_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveCob_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveCob_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveRoot_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "2e145cafeb8dcff4143170c76b193816";

export default node;
